import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import {
  CommandDialog, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem,
} from "@/components/ui/command";
import { ListTodo, FolderKanban, Users, TrendingUp } from "lucide-react";

export default function CommandPalette({ open, setOpen }) {
  const nav = useNavigate();
  const [q, setQ] = useState("");
  const [res, setRes] = useState({ tasks: [], projects: [], clients: [], deals: [] });

  useEffect(() => {
    if (!q || q.length < 2) { setRes({ tasks: [], projects: [], clients: [], deals: [] }); return; }
    const t = setTimeout(async () => {
      try { const { data } = await api.get("/search", { params: { q } }); setRes(data); } catch {}
    }, 250);
    return () => clearTimeout(t);
  }, [q]);

  const go = (path) => { setOpen(false); setQ(""); nav(path); };

  return (
    <CommandDialog open={open} onOpenChange={setOpen} shouldFilter={false}>
      <CommandInput placeholder="Görev, proje, müşteri, fırsat ara..." value={q} onValueChange={setQ} data-testid="global-search-input" />
      <CommandList>
        <CommandEmpty>Sonuç bulunamadı.</CommandEmpty>
        <CommandGroup heading="Hızlı Erişim">
          <CommandItem onSelect={() => go("/tasks")}><ListTodo className="h-4 w-4 mr-2" /> Görevler</CommandItem>
          <CommandItem onSelect={() => go("/projects")}><FolderKanban className="h-4 w-4 mr-2" /> Projeler</CommandItem>
        </CommandGroup>
        {res.tasks.length > 0 && (
          <CommandGroup heading="Görevler">
            {res.tasks.map((t) => <CommandItem key={t.id} onSelect={() => go(`/tasks?id=${t.id}`)}><ListTodo className="h-4 w-4 mr-2" /> {t.title}</CommandItem>)}
          </CommandGroup>
        )}
        {res.projects.length > 0 && (
          <CommandGroup heading="Projeler">
            {res.projects.map((p) => <CommandItem key={p.id} onSelect={() => go(`/projects/${p.id}`)}><FolderKanban className="h-4 w-4 mr-2" /> {p.name}</CommandItem>)}
          </CommandGroup>
        )}
      </CommandList>
    </CommandDialog>
  );
}
